<template>
  <div class="carousel-container">
    <transition name="fade" mode="out-in">
      <!-- показываем картинку только если она есть -->
      <img
        v-if="currentSlide.url"
        :src="currentSlide.url"
        :key="currentSlide.id"
        class="carousel-img"
      />
      <!-- если нет слайдов -->
      <div v-else class="no-slide">Нет картинок</div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Carousel",
  props: {
    slides: {
      type: Array,
      required: true
    },
    delay: {
      type: Number,
      default: 3000
    }
  },
  data() {
    return {
      current: 0,
      timer: null,
      prevLength: 0
    };
  },
  computed: {
    currentSlide() {
      // безопасный доступ
      return this.slides[this.current] || {};
    }
  },
  watch: {
    slides: {
      handler(newSlides) {
        // 1) если после удаления индекс вышел за пределы —
        if (this.current >= newSlides.length) {
          this.current = 0;
        }
        // 2) если количество слайдов изменилось, перезапускаем autoplay
        if (newSlides.length !== this.prevLength) {
          this._restartTimer(newSlides.length);
          this.prevLength = newSlides.length;
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.prevLength = this.slides.length;
    this._restartTimer(this.slides.length);
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
  methods: {
    next() {
      this.current = (this.current + 1) % this.slides.length;
    },
    _restartTimer(length) {
      clearInterval(this.timer);
      // если более одного слайда — запускаем
      if (length > 1) {
        this.timer = setInterval(this.next, this.delay);
      }
    }
  }
};
</script>

<style scoped>
.carousel-container {
  position: relative;
  width: 100%;
  height: 400px; /* подгоните под ваш дизайн */
  overflow: hidden;
}
.carousel-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.no-slide {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #666;
  font-style: italic;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
